import { MapsAPILoader } from '@agm/core';
import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  Optional,
  ViewChild
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MatTableDataSource,
  MAT_DIALOG_DATA
} from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { DTOAddressHistory } from '../../../../../@core/models/DTOAddressHistory';
import { DTOShipment } from '../../../../../@core/models/DTOShipment';
import { ShipmentService } from '../../../../../@core/services/shipment.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel
} from '../../../../../@theme/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'crm-address-change-dialog',
  templateUrl: './crm-address-change-dialog.component.html',
  styleUrls: ['./crm-address-change-dialog.component.scss']
})
export class CrmAddressChangeDialogComponent implements OnInit {
  addresstext: string;
  private geoCoder;

  entity: any;
  history: any;

  city: string;
  civicnumber: string;
  street: string;
  province: string;
  country: string;
  postalcode: string;
  zoom: number;
  name: string;
  address: string;
  appartment: string;
  aptsuitelocal: string;
  addressformat: string;
  address1: string;
  address2: string;

  oldname: string;
  namechanged: string;
  oldcity: string;
  citychanged: boolean;
  oldpostalcode: string;
  postalcodechanged: boolean;
  oldaddress1: string;
  address1changed: boolean;
  oldaddress2: string;
  address2changed: boolean;
  oldnote: string;
  selText: string;
  userId: string;
  key: string;
  lang: string;
  shipmentStatus: string;

  address1checked: boolean;
  address2checked: boolean;
  error: string = '';
  displayedColumns: string[] = [
    'Iteration',
    'AccountName',
    'Address',
    'City',
    'PostalCode',
    'HistoryDate'
  ];

  @ViewChild('search', { static: true }) searchElementRef: ElementRef;
  addressHistoryDatasource = new MatTableDataSource<DTOAddressHistory>(null);

  constructor(
    public dialogRef: MatDialogRef<CrmAddressChangeDialogComponent>,
    private mapsAPILoader: MapsAPILoader,
    public dialog: MatDialog,
    private translateService: TranslateService,
    private _shipmentService: ShipmentService,
    private ngZone: NgZone,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data.editDestination) {
      this.entity = this.data.shipment.Destination;
      this.history = this.data.shipment.DestinationHistory;
    } else {
      this.entity = this.data.shipment.Sender;
      this.history = this.data.shipment.SenderHistory;
    }

    if (this.entity.Address2) {
      this.addresstext = this.entity.Address1 + ' ' + this.entity.Address2;
    } else {
      this.addresstext = this.entity.Address1;
    }

    this.userId = this.data.userId;
    this.key = this.data.key;
    this.name = this.entity.AccountName;
    this.address1 = this.entity.Address1;
    this.address2 = this.entity.Address2;
    if (
      this.data.shipment.DestinationHistory &&
      this.data.shipment.DestinationHistory.length > 0
    ) {
      this.addressHistoryDatasource = new MatTableDataSource<DTOAddressHistory>(
        this.data.shipment.DestinationHistory
      );
    } else if (
      this.data.shipment.SenderHistory &&
      this.data.shipment.SenderHistory.length > 0
    ) {
      this.addressHistoryDatasource = new MatTableDataSource<DTOAddressHistory>(
        this.data.shipment.SenderHistory
      );
    }

    this.oldname = this.entity.AccountName;
    this.namechanged = this.entity.AccountNameChanged;
    this.oldcity = this.entity.City;
    this.citychanged = this.entity.CityChanged;
    this.oldaddress1 = this.entity.Address1;
    this.address1changed = this.entity.Address1Changed;
    this.oldaddress2 = this.entity.Address2;
    this.address2changed = this.entity.Address2Changed;
    this.oldpostalcode = this.entity.PostalCode;
    this.postalcodechanged = this.entity.PostalCodeChanged;
    this.postalcode = this.oldpostalcode;
    this.address2 = this.oldaddress2;
    this.address1 = this.oldaddress1;
    this.city = this.oldcity;
    this.shipmentStatus = this.data.shipment.ShipmentStatus;

    // this.parseAddress();
    //+ ' ' + this.data.shipment.Destination.Postal_Code
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();

      this.searchElementRef.nativeElement.click();

      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ['address'],
          componentRestrictions: { country: 'ca' }
        }
      );

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom

          this.civicnumber = '';
          this.street = '';
          this.city = '';
          this.province = '';
          this.country = '';
          this.postalcode = '';

          for (var j = 0; j < place.address_components.length; j++) {
            if (place.address_components[j].types[0] === 'street_number') {
              this.civicnumber = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'route') {
              this.street = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'locality') {
              this.city = place.address_components[j].long_name;
            }

            if (
              place.address_components[j].types[0] ===
              'administrative_area_level_1'
            ) {
              this.province = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'country') {
              this.country = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'postal_code') {
              this.postalcode = place.address_components[j].long_name.replace(
                /\s/g,
                ''
              );
            }
          }

          //this.address1 = this.civicnumber + ' ' + this.street + ', ' + this.city + ', ' + this.province + ' ' + this.country;
          this.address2 = '';

          this.address1 = place.name;
          this.address2 = '';
          this.zoom = 12;
        });
      });
    });
  }

  public getAddress(latitude, longitude) {
    this.civicnumber = '';
    this.street = '';
    this.city = '';
    this.province = '';
    this.country = '';
    this.postalcode = '';

    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            this.addresstext = results[0].formatted_address;

            this.ngZone.run(() => {
              //get the place result
              //   let place: google.maps.places.PlaceResult = autocomplete.getPlace();

              //   //verify result
              //   if (place.geometry === undefined || place.geometry === null) {
              //     return;
              //   }

              //   //set latitude, longitude and zoom

              for (var j = 0; j < results[0].address_components.length; j++) {
                if (
                  results[0].address_components[j].types[0] === 'street_number'
                ) {
                  this.civicnumber = results[0].address_components[j].long_name;
                }

                if (results[0].address_components[j].types[0] === 'route') {
                  this.street = results[0].address_components[j].long_name;
                }

                if (results[0].address_components[j].types[0] === 'locality') {
                  this.city = results[0].address_components[j].long_name;
                }

                if (
                  results[0].address_components[j].types[0] ===
                  'administrative_area_level_1'
                ) {
                  this.province = results[0].address_components[j].long_name;
                }

                if (results[0].address_components[j].types[0] === 'country') {
                  this.country = results[0].address_components[j].long_name;
                }

                if (
                  results[0].address_components[j].types[0] === 'postal_code'
                ) {
                  this.postalcode = results[0].address_components[
                    j
                  ].long_name.replace(/\s/g, '');
                }
              }

              this.address1 =
                this.civicnumber +
                ' ' +
                this.street +
                ', ' +
                this.city +
                ', ' +
                this.province +
                ' ' +
                this.country;
              this.address2 = '';
            });
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      }
    );
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public confirmSave(): void {
    /*if (
      this.shipmentStatus === 'Cancelled' ||
      this.shipmentStatus === 'OnHold'
    ) {*/
    const message = this.translateService.instant(
      'crm.confirm-reactivate-shipment'
    );

    const dialogData = new ConfirmDialogModel('Confirm Action', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: `400px`,
      data: dialogData,
      position: { top: '100px' }
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.save(true);
      } else {
        this.save(false);
      }
    });
    /* } else {
      this.save(false);
    }*/
  }

  public save(reactivate: boolean): void {
    this.error = '';
    this.entity.AccountName = this.name;
    this.entity.Address1 = this.address1;
    this.entity.Address2 = this.address2;
    this.entity.City = this.city;
    this.entity.PostalCode = this.postalcode;

    this._shipmentService
      .UpdateShipment(this.data.shipment, this.userId, this.key, reactivate)
      .subscribe(
        (res) => {
          this.dialogRef.close(false);
        },
        (e) => {
          this.error = e.error.message;
        }
      );
  }

  public onClickParseAddress() {
    this.parseAddress();
  }

  public Search(address1checked) {
    this.ngZone.run(() => {
      this.addresstext = '';
      // if (this.data.shipment.Destination.Address2) {
      //   this.addresstext = this.data.shipment.Destination.Address1 + ' ' + this.data.shipment.Destination.Address2;
      // }
      // else {
      //   this.addresstext = this.data.shipment.Destination.Address1;
      // }

      if (this.address1checked) {
        this.addresstext += ' ' + this.address1;
      }

      this.searchElementRef.nativeElement.focus();
      this.searchElementRef.nativeElement.click();
    });
  }
  public parseAddress() {
    let civicnumberlkup =
      /^^([a-z0-9].*?[\.\/\,]?[a-z0-9]?)\s(Av?E?N?U?E?|chemin|pla?c?e?|che?m?i?n?|route|rang|boulevard|bd|blvd|bvld?|boul|rue|montee)(?:\s?\.?\,?)+(.*)/i.exec(
        this.entity.Address1
      );
    // let appartementlkup = /(?=app|apt|appt|appart|appartement|#)(app|apt|appt|appart|appartement|#)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(this.data.shipment.Destination.Address1);
    let appartementlkup =
      /(floor(?!.*floor)|local(?!.*local)|unit(?!.*unit)|suite(?!.*suite))(.*)/i.exec(
        this.entity.Address1
      );
    let suitelkup =
      /^(.*?)(suite(?!.*suite)|suite\s?#(?!.*suite\s?#)|suite\s?:(?!.*suite\s?:)|suit(?!.*suit)|#(?!.*#))\s*,*\.*\s?\s*([a-z0-9]+[-]*[a-z0-9]*)(.*)/i.exec(
        this.addresstext
      );
    let bureaulkup =
      /(?=bur|bureau)(bur|bureau)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(
        this.entity.Address1
      );
    let floorlkup =
      /(etage)\s\d+|(((?:1i?er|1\s?i?ere?|premier|\d+(?:\s*)e?i?e?è?m?e?|\d+(?:\s*)er|\d+(?:\s*)?ii?e?è?me|\d+(?:\s*)?iemes|\d+(?:\s*)?e?è?me|\d+(?:\s*)?ie?è?me?|\d+(?:\s*)?e|\d\d(?:\s*)?e|\d\d?(?:\s*)?th|main(?:\s*)?|first(?:\s*)?|1st(?:\s*)?|second(?:\s*)?|\dnd(?:\s*)?|third(?:\s*)?|3rd(?:\s*)?|fourth(?:\s*)?|fifth(?:\s*)?|sixth(?:\s*)?|seventh(?:\s*)?|eighth(?:\s*)?|nineth(?:\s*)?|tenth(?:\s*)?))(?:[\s\.\:\-\,]*)(fl\.|flo?o?r?|e?é?tage))(.*)|é?e?tage\s#?\d+/i.exec(
        this.entity.Address1
      );

    // this.addresstext

    if (civicnumberlkup) {
      this.civicnumber = civicnumberlkup[1];
    } else {
      civicnumberlkup = /^([a-z0-9-\/\.?]*)(,|\s)(.*)/i.exec(
        this.entity.Address2
      );
    }

    if (appartementlkup) {
      this.aptsuitelocal = appartementlkup[0];
      this.addresstext = this.addresstext.replace(appartementlkup[0], '');
    } else {
      appartementlkup =
        /(?=app|apt|appt|appart|appartement|#)(app|apt|appt|appart|appartement|#)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(
          this.entity.Address2
        );
      if (appartementlkup) {
        this.aptsuitelocal = appartementlkup[0];
        this.addressformat = this.entity.Address2.replace(
          appartementlkup[0],
          ''
        );
      }
    }

    if (floorlkup) {
      this.aptsuitelocal = floorlkup[0];
      this.addressformat = this.entity.Address1.replace(floorlkup[0], '');
    } else {
      floorlkup =
        /(etage)\s\d+|(((?:1i?er|1\s?i?ere?|premier|\d+(?:\s*)e?i?e?è?m?e?|\d+(?:\s*)er|\d+(?:\s*)?ii?e?è?me|\d+(?:\s*)?iemes|\d+(?:\s*)?e?è?me|\d+(?:\s*)?ie?è?me?|\d+(?:\s*)?e|\d\d(?:\s*)?e|\d\d?(?:\s*)?th|main(?:\s*)?|first(?:\s*)?|1st(?:\s*)?|second(?:\s*)?|\dnd(?:\s*)?|third(?:\s*)?|3rd(?:\s*)?|fourth(?:\s*)?|fifth(?:\s*)?|sixth(?:\s*)?|seventh(?:\s*)?|eighth(?:\s*)?|nineth(?:\s*)?|tenth(?:\s*)?))(?:[\s\.\:\-\,]*)(fl\.|flo?o?r?|e?é?tage))(.*)|é?e?tage\s#?\d+/i.exec(
          this.entity.Address2
        );
      if (floorlkup) {
        this.aptsuitelocal = floorlkup[0];
        this.addressformat =
          this.entity.Address1 +
          ' ' +
          this.entity.Address2.replace(floorlkup[0], '');
      }
    }

    if (suitelkup) {
      this.aptsuitelocal = suitelkup[0];
      this.addressformat = this.entity.Address1.replace(suitelkup[0], '');
    } else {
      suitelkup =
        /^(.*?)(suite(?!.*suite)|suite\s?#(?!.*suite\s?#)|suite\s?:(?!.*suite\s?:)|suit(?!.*suit)|#(?!.*#))\s*,*\.*\s?\s*([a-z0-9]+[-]*[a-z0-9]*)(.*)/i.exec(
          this.entity.Address2
        );
      if (suitelkup) {
        this.aptsuitelocal = suitelkup[0];
        this.addressformat =
          this.entity.Address1 +
          ' ' +
          this.entity.Address2.replace(suitelkup[0], '');
        this.addresstext = this.addresstext.replace(suitelkup[0], '');
      }
    }

    if (bureaulkup) {
      this.aptsuitelocal = bureaulkup[0];
      this.addressformat = this.entity.Address1.replace(bureaulkup[0], '');
    } else {
      bureaulkup =
        /(?=bur|bureau)(bur|bureau)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(
          this.entity.Address2
        );
      if (bureaulkup) {
        this.addressformat = this.entity.Address2.replace(bureaulkup[0], '');
      }
    }
  }
  public OnSelectInput() {
    var text = '';
    if (window.getSelection) {
      text = window.getSelection().toString();
    } else if (
      document.getSelection() &&
      document.getSelection().type != 'Control'
    ) {
    }
    this.selText = text;
  }
}
